import { z } from "zod"

export const EmployeeCompanyAccessResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  employeeId: z.bigint().transform(String),
  companyId: z.bigint().transform(String),
  companyName: z.string(),
  grantedAt: z.date().transform((value) => value.toISOString()),
  grantedByName: z.string(),
})

export type EmployeeCompanyAccessResponseData = z.infer<
  typeof EmployeeCompanyAccessResponseDataSchema
>

export const EmployeeCompanyAccessesResponseDataSchema = z.array(
  EmployeeCompanyAccessResponseDataSchema,
)

export type EmployeeCompanyAccessesResponseData = z.infer<
  typeof EmployeeCompanyAccessesResponseDataSchema
>
